// Pages
import PushPage from './PushPage';

// React
import React, { useEffect, useState, useRef } from 'react';
import 'react-tagsinput/react-tagsinput.css';

// Confetti
import ConfettiExplosion from 'react-confetti-explosion';

// Antd Mobile
import { Swiper } from 'antd-mobile'

// Telegram UI
import { AppRoot, Badge, Button, Blockquote, Cell, Headline, Subheadline, IconButton, IconContainer, Navigation, Section, Switch } from '@telegram-apps/telegram-ui';

// VK
import { Avatar } from '@vkontakte/vkui';

// Icons
import { ReactComponent as PostsIcon } from "../assets/posts.svg";
import { ReactComponent as PostingIcon } from "../assets/posting.svg";
import { ReactComponent as ModeIcon } from "../assets/mode.svg";
import { ReactComponent as StreamsIcon } from "../assets/streams.svg";
import { ReactComponent as StreamsOutlineIcon } from "../assets/streams_outline.svg";
import { ReactComponent as HelpIcon } from "../assets/help.svg";
import { ReactComponent as PlanIcon } from "../assets/plan.svg";
import { ReactComponent as FilterIcon } from "../assets/filter.svg";
import { ReactComponent as SourcesIcon } from "../assets/sources.svg";
import { ReactComponent as StyleIcon } from "../assets/style.svg";
import { ReactComponent as TimersIcon } from "../assets/timers.svg";
import { ReactComponent as OtherIcon } from "../assets/other.svg";
import { ReactComponent as RightArrow } from "../assets/right_arrow.svg";

const tg = window.Telegram.WebApp;

const OnboardingPage = ({ activePanel, setActivePanel, avatarSrc, selectedGroup, setSelectedGroup, premodePosts, setChannels, setGroups, setPremodePosts, selectedStreamIndex, setSelectedStreamIndex, stream, setStream }) => {
    const filteredPosts = premodePosts.filter(post => selectedGroup === null || post.id === selectedGroup.id);
    const streams = selectedGroup.streams;

    const [switchChecked, setSwitchChecked] = useState(selectedGroup.active);

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('home');
        };

        if (activePanel === 'onboarding') {
            tg.BackButton.show();
            console.log(streams)
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);


    return (
        <div className="wrapperUI onboardingUI">
            <AppRoot platform='ios'>
                <div className="onboardingWrapper">
                    <ConfettiExplosion />
                    <Headline style={{ textAlign: "center" }} weight="2">
                        {String(selectedGroup.id).startsWith("-200") ? (
                            "RSS-лента успешно добавлена!"
                        ) : String(selectedGroup.id).startsWith("-100") && !selectedGroup.group ? (
                            "Канал успешно добавлен!"
                        ) : String(selectedGroup.id).startsWith("-100") && selectedGroup.group ? (
                            "Группа успешно добавлена!"
                        ) : String(selectedGroup.id).startsWith("-") && !String(selectedGroup.id).startsWith("-100") && !String(selectedGroup.id).startsWith("-200") && !String(selectedGroup.id).startsWith("-30") ? (
                            "Канал Max успешно добавлен!"
                        ) : null}
                    </Headline>

                    <Section className="sectionOnboarding">
                        <Cell
                            className="sectionOnboardingItems"
                            hovered={false}
                            before={<Avatar className="channelAvatar" size={75} initials={selectedGroup.name.substring(0, 2)} src={avatarSrc} />}
                            subtitle={
                                String(selectedGroup.id).startsWith("-200")
                                    ? undefined
                                    : `${selectedGroup.members_count} подписчиков`
                            }
                        >
                            {selectedGroup.name}
                        </Cell>
                    </Section>

                    {/* <Headline style={{ textAlign: "center" }} weight="3">Давайте настроим его?</Headline> */}
                    <div className="onboardingButtonGroups">
                        <Button className="onboardingButtonSet" onClick={() => { setActivePanel('channel'); }} mode="filled" size="m" after={<IconContainer className="onboardingArrowRight" style={{ color: 'var(--tgui--button_text_color)' }}><RightArrow /></IconContainer>}>Начать пользоваться</Button>
                        {/* <Button className="onboardingButtonSetSecond" onClick={() => { setActivePanel('home'); }} mode="bezeled" size="m">Я настрою позже сам</Button> */}
                    </div>
                </div>
            </AppRoot>
        </div>
    );
};

export default OnboardingPage;